<template>
    <v-btn-toggle
        variant="outlined"
        density="compact"
        :required="required"
        divided
    >
        <v-btn
            v-if="!hideNoAnswer"
            class="flex-shrink-1 flex-grow-1"
            value=""
            :size="size"
        >
            No Answer
        </v-btn>
        <v-btn
            class="flex-shrink-1 flex-grow-1"
            value="M"
            :size="size"
        >
            Male
        </v-btn>
        <v-btn
            class="flex-shrink-1 flex-grow-1"
            value="F"
            :size="size"
        >
            Female
        </v-btn>
    </v-btn-toggle>
</template>

<script lang="ts" setup>
    const props = withDefaults(
        defineProps<{
            required?: boolean;
            hideNoAnswer?: boolean;
            size?: string | number;
        }>(),
        {
            required: false,
            hideNoAnswer: false,
            size: 'default'
        }
    );
</script>
